import { Component, OnDestroy } from '@angular/core';
import { Icon } from '@types-custom/models/ui/icon-model';
import { ODMatrizService } from '@shared/services/odmatriz-service/odmatriz.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'panel-matrix-od-sensor',
  templateUrl: './panel-matrix-od.component.html',
  styleUrls: ['./panel-matrix-od.component.scss'],
})
export class PanelMatrixOdComponent implements OnDestroy{
  Icon = Icon;

  ActiveSensor : any = undefined;
  formatDate : {start:string,end:string} = {start:'',end:''}
  Subscription1 : Subscription = undefined;

  constructor(
    private odMatrixService : ODMatrizService
  ) {
    this.Subscription1 = this.odMatrixService.activeSensor$.subscribe((res : any) => {
      this.ActiveSensor = res;

      if(this.ActiveSensor?.timeStart && this.ActiveSensor?.timeEnd  ){
        this.formatDate.start = this.ActiveSensor.timeStart.split("T").join(" ")
        this.formatDate.end = this.ActiveSensor.timeEnd.split("T").join(" ")
      }
    })
  }

  ngOnDestroy() {
    if(this.Subscription1) {
      this.Subscription1.unsubscribe()
    }
    this.odMatrixService.sensorActiveSubject.next(undefined)
  }
}
